import service from '@/store/services/my-data-service';

const state = {
  list: {},
  myData: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, myData) => {
    state.myData = myData;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service
      .list(params)
      .then((list) => {
        if (list.hasOwnProperty('data') && list.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              list.data.errorCode,
            { root: true }
          );
        }
        commit('SET_LIST', list);
        return list;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },

  get({ commit, dispatch }, params) {
    return service
      .get(params)
      .then((myData) => {
        if (myData.hasOwnProperty('data') && myData.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              myData.data.errorCode,
            { root: true }
          );
        }
        commit('SET_RESOURCE', myData);
        return myData;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },

  add({ commit, dispatch }, params) {
    return service
      .add(params)
      .then((myData) => {
        if (myData.hasOwnProperty('data') && myData.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              myData.data.errorCode,
            { root: true }
          );
        }
        commit('SET_RESOURCE', myData);
        return myData;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },

  csv({ commit, dispatch }, params) {
    return service
      .csv(params)
      .then((myData) => {
        if (myData.hasOwnProperty('data') && myData.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              myData.data.errorCode,
            { root: true }
          );
        }
        commit('SET_RESOURCE', myData);
        return myData;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },

  update({ commit, dispatch }, params) {
    return service
      .update(params)
      .then((myData) => {
        if (myData.hasOwnProperty('data') && myData.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              myData.data.errorCode,
            { root: true }
          );
        }
        commit('SET_RESOURCE', myData);
        return myData;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  myData: (state) => state.myData,
};

const myData = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default myData;
